<script>
	import { getAvatarUrl } from '../discord';
    export let user;
</script>

<style>
	.profile-image {
		height: 40px;
		width: 40px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		border-radius: 50%;
	}
</style>

{#if user.profileImage}
<!-- TODO: for mock data only, get rid of this -->
<div class="profile-image" style="background-image: url({user.profileImage});"/>
{:else if user.photoURL}
<div class="profile-image" style="background-image: url({user.photoURL});"/>
{:else}
<div class="profile-image" style="background-color: #7077f4;"/>
{/if}
